import React from "react";
import Cookies from "universal-cookie";


export const Navbar = (props) => {

    const cookies = new Cookies();

    const handleLogout = () => {
        console.log("logout");
        
        cookies.remove('id', {path: '/'})
        cookies.remove('correo', {path: '/'})
        cookies.remove('password', {path: '/'})
        cookies.remove('nombre', {path: '/'})

        cookies.remove('nombre', {path: '/'})
        cookies.remove('apellido', {path: '/'})
        cookies.remove('imagen', {path: '/'})

        window.location.replace('/');
    };

    return (
        <nav className="navbar navbar-expand-sm navbar-dark bg-dark">
            <div className="navbar-collapse collapse w-100 order-3 dual-collapse2 d-flex justify-content-end">
                <ul className="navbar-nav ml-auto">
                    <span className="nav-item nav-link text-info">Hola, {props.nombre}</span>
                    <button className="nav-item nav-link btn" onClick={handleLogout}>
                        Salir
                    </button>
                </ul>
            </div>
        </nav>
    );
};
